import { render, staticRenderFns } from "./SearchTypeSelect.vue?vue&type=template&id=4f7c2bd5&scoped=true&"
import script from "./SearchTypeSelect.vue?vue&type=script&lang=js&"
export * from "./SearchTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7c2bd5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f7c2bd5')) {
      api.createRecord('4f7c2bd5', component.options)
    } else {
      api.reload('4f7c2bd5', component.options)
    }
    module.hot.accept("./SearchTypeSelect.vue?vue&type=template&id=4f7c2bd5&scoped=true&", function () {
      api.rerender('4f7c2bd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/form/SearchTypeSelect.vue"
export default component.exports